// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zu2O9","title":"Header_title__8JLrh","side":"Header_side__16GfZ"};